import firebase from 'firebase'

export default {
  created () {
  },

  mounted () {
  },

  computed: {
    isReminderUpdate: {
      get () {
        return this.$store.state.isReminderUpdate.flg
      },
      set (payload) {
        this.$store.commit('isReminderUpdate/set', payload)
      }
    }
  },

  filters: {
  },

  data () {
    return {
      // remindDates: [
      //   {text: '30日後', val: 30}
      //   // {text: '１週間後', val: 7},
      //   // {text: '２週間後', val: 14},
      // ],

      triggerDays: 7, // リマインド日から7日間ログイン無しでトリガー
      reminder: {
        id: '',
        email: '',
        remindSelect: null,
        remindDate: 0,
        isValid: true,
        version: 1
      }
      // selectedRemind: null
    }
  },

  methods: {
    updateReminder () {
      if (this.isReminderUpdate) {
        return
      } else {
        this.isReminderUpdate = true
      }
      // const self = this
      const onCall = firebase.app().functions('asia-northeast1').httpsCallable('updateReminderOnCall')
      const data = {
        // userId: this.user.userId,
        userId: this.account.uid,
        email: this.account.email
      }
      // ライセンスチェックはファンクションで行う。
      onCall(data)
      .then((result) => {
        console.log('Update Reminder: ', result)
      })
      .catch((error) => {
        console.log('Error updateReminderOnCall: ', error)
      })
    },

    delReminder () {
      // const self = this
      const onCall = firebase.app().functions('asia-northeast1').httpsCallable('delReminderOnCall')
      const data = {
        userId: this.account.uid
      }
      onCall(data)
      .then((result) => {
        console.log('Delete Reminder: ', result)
      })
      .catch((error) => {
        console.log('Error delReminder: ', error)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/com_reminder.js